export const useOfferBarVisible = () => {
  return process.env.REACT_APP_SHOW_OFFER_BAR === 'true';
};
